import { render, staticRenderFns } from "./BirthYearSelect.vue?vue&type=template&id=28426c55&scoped=true"
import script from "./BirthYearSelect.vue?vue&type=script&lang=js"
export * from "./BirthYearSelect.vue?vue&type=script&lang=js"
import style0 from "./BirthYearSelect.vue?vue&type=style&index=0&id=28426c55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.29.0__css-loader@7.1.2_webpa_3d7f2ab3f5a7be661676221dc492acf0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28426c55",
  null
  
)

export default component.exports